import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Dimmer, Loader } from "semantic-ui-react";

import { DATE_FORMATS_FNS, ReactTable } from "components";
import { useMetricsQuery } from "modules/UsersDashboard/components/EditUserModal/hooks";
import { formatDate } from "utils/dateHelperFunctions";

import type { NetworkMetrics } from "models";

type MetricsTableProps = {
  userId: number | null;
};

const columnHelper = createColumnHelper<NetworkMetrics>();

export const MetricsTable = ({ userId }: MetricsTableProps) => {
  const { t } = useTranslation();

  const { data, isFetching } = useMetricsQuery(userId);

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "date",
        header: () => <span> {t("v8_date", "Date")} </span>,
        cell: ({
          row: {
            original: { created_on }
          }
        }) => (
          <span className="no-wrap-text">
            {formatDate(created_on, DATE_FORMATS_FNS.dateMonthYear)} | {formatDate(created_on, DATE_FORMATS_FNS.hoursMinutesSeconds)}
          </span>
        ),
        size: 100
      }),

      columnHelper.accessor(row => row, {
        id: "delay_claire",
        header: () => <span> {t("v8_delay_claire", "Delay Claire")} </span>,
        cell: ({
          row: {
            original: { delay_claire }
          }
        }) => <span className="no-wrap-text">{delay_claire}</span>,
        size: 100
      }),

      columnHelper.accessor(row => row, {
        id: "delay_outside",
        header: () => <span> {t("v8_delay_outside", "Delay Outside")} </span>,
        cell: ({
          row: {
            original: { delay_outside }
          }
        }) => <span className="no-wrap-text">{delay_outside}</span>,
        size: 100
      }),

      columnHelper.accessor(row => row, {
        id: "ping_claire",
        header: () => <span> {t("v8_ping_claire", "Ping Claire")} </span>,
        cell: ({
          row: {
            original: { ping_claire }
          }
        }) => <span className="no-wrap-text">{ping_claire}</span>,
        size: 100
      }),

      columnHelper.accessor(row => row, {
        id: "ping_outside",
        header: () => <span> {t("v8_ping_outside", "Ping Outside")} </span>,
        cell: ({
          row: {
            original: { ping_outside }
          }
        }) => <span className="no-wrap-text">{ping_outside}</span>,
        size: 100
      }),

      columnHelper.accessor(row => row, {
        id: "wifi_name",
        header: () => <span> {t("v8_wifi_name", "Wi-Fi Name")} </span>,
        cell: ({
          row: {
            original: { wifi_name }
          }
        }) => <span className="no-wrap-text">{wifi_name}</span>,
        size: 100
      }),

      columnHelper.accessor(row => row, {
        id: "wifi_strength",
        header: () => <span> {t("v8_wifi_strength", "Wi-Fi Strength")} </span>,
        cell: ({
          row: {
            original: { wifi_strength }
          }
        }) => <span className="no-wrap-text">{wifi_strength}</span>,
        size: 100
      })
    ],
    [t]
  );

  return (
    <Dimmer.Dimmable dimmed={isFetching}>
      <Dimmer active={isFetching} inverted>
        <Loader active inline="centered" />
      </Dimmer>
      <ReactTable columns={columns} data={data} />
    </Dimmer.Dimmable>
  );
};
